webpackJsonp([3],{

/***/ "JzQ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Toggle__ = __webpack_require__("2+yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router__ = __webpack_require__("/QC5");





var QuestionList = function QuestionList(_ref) {
  var questions = _ref.questions,
      updateQuestion = _ref.updateQuestion,
      updateQuestionStatus = _ref.updateQuestionStatus;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    null,
    questions.map(function (question, index) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        { 'class': 'edit-question' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'label',
          { 'for': question.slug + '_title' },
          'Q',
          index + 1
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
          id: question.slug + '_title',
          type: 'text',
          dir: 'auto',
          value: question.text,
          onInput: function onInput(event) {
            return updateQuestion(question.slug, event.target.value);
          }
        }),
        updateQuestionStatus && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__Toggle__["a" /* Toggle */], {
          label: 'Active',
          on: question.status === 'live',
          onToggle: function onToggle() {
            return updateQuestionStatus(question.slug, question.status === 'live' ? 'draft' : 'live');
          }
        })
      );
    })
  );
};



/***/ }),

/***/ "ZUAp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_slugify__ = __webpack_require__("KGMw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_date__ = __webpack_require__("8EZx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_QuestionList__ = __webpack_require__("JzQ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AddQuestion__ = __webpack_require__("CZP8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_unistore_preact__ = __webpack_require__("o6ac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_unistore_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_unistore_preact__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var today = Object(__WEBPACK_IMPORTED_MODULE_3__utils_date__["l" /* url */])();

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: '/assets/images/welcome.svg', 'class': 'home-image', alt: '' });

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'h1',
  { 'class': 'center h1' },
  'Here are a few popular daily questions to get you started:'
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'center lift--without-delay mt20' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
    { href: today, 'class': 'button' },
    'Start writing!'
  )
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
  { 'class': 'button button--grey', href: '/add-statistic-question' },
  'Add a personal statistic to track'
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'center lift--without-delay mt20 mb40' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
    { href: today, 'class': 'button' },
    'Start writing!'
  )
);

var GetStarted = function (_Component) {
  _inherits(GetStarted, _Component);

  function GetStarted() {
    var _temp, _this, _ret;

    _classCallCheck(this, GetStarted);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      questions: [],
      defaultQuestions: ["What's happened today?", 'What are you thankful for?', 'What would you change about today?', 'Notes and musings', 'What did you work on yesterday?', 'What are you planning on working on today?']
    }, _this.updateQuestion = function (slug, value) {
      var attribute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';

      var questions = [].concat(_this.state.questions);
      var question = questions.find(function (x) {
        return x.slug === slug;
      });
      if (!question) {
        return;
      }

      question[attribute] = value;
      _this.props.db.set('questions', slug, question);

      _this.setState({ questions: questions });
    }, _this.updateQuestionStatus = function (slug, value) {
      _this.updateQuestion(slug, value, 'status');
    }, _this.addQuestionToDB = function (text) {
      var $args = arguments;return new Promise(function ($return, $error) {
        var callback, slug, question, questions;
        callback = $args.length > 1 && $args[1] !== undefined ? $args[1] : function () {
          return null;
        };

        slug = Object(__WEBPACK_IMPORTED_MODULE_1__utils_slugify__["a" /* slugify */])(text);
        question = { slug: slug, text: text, status: 'live', createdAt: Date.now() };

        return Promise.resolve(_this.props.db.set('questions', slug, question)).then(function ($await_1) {
          try {

            _this.onboard();
            questions = [].concat(_this.state.questions);
            questions.push(question);
            _this.setState({ questions: questions });
            callback();
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }, _this.addDefaultQuestion = function (event) {
      _this.addQuestionToDB(event.target.textContent);
    }, _this.addQuestion = function (event) {
      event.preventDefault();
      _this.addQuestionToDB(event.target.question.value, function () {
        event.target.reset();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  GetStarted.prototype.componentWillMount = function componentWillMount() {
    return new Promise(function ($return, $error) {
      var _this2, keys, questions;

      _this2 = this;
      return Promise.resolve(this.props.db.keys('questions')).then(function ($await_2) {
        try {
          keys = $await_2;
          return Promise.resolve(Promise.all(keys.map(function (x) {
            return _this2.props.db.get('questions', x);
          }))).then(function ($await_3) {
            try {
              questions = $await_3;
              questions.sort(function (a, b) {
                return a.createdAt - b.createdAt;
              });

              this.setState({ questions: questions });
              return $return();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    }.bind(this));
  };

  GetStarted.prototype.onboard = function onboard() {
    localStorage.setItem('journalbook_onboarded', true);
  };

  GetStarted.prototype.render = function render(props, _ref) {
    var _this3 = this;

    var questions = _ref.questions,
        defaultQuestions = _ref.defaultQuestions;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': 'wrap lift-children' },
      _ref2,
      _ref3,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': 'default-questions' },
        defaultQuestions.map(function (q) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'button',
            {
              type: 'button',
              'class': 'default-question',
              disabled: questions.find(function (x) {
                return x.text === q;
              }),
              onClick: _this3.addDefaultQuestion
            },
            q
          );
        })
      ),
      questions && questions.length ? _ref4 : null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__components_AddQuestion__["a" /* AddQuestion */], {
        addQuestion: this.addQuestion,
        label: 'Or write your own!',
        plus: true
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'mb40' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'a',
          {
            'class': 'button button--grey mr20',
            onClick: this.onboard,
            href: '/settings'
          },
          'Import an existing JournalBook'
        ),
        _ref5
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__components_QuestionList__["a" /* QuestionList */], {
        questions: questions,
        updateQuestion: this.updateQuestion,
        updateQuestionStatus: this.updateQuestionStatus
      }),
      questions && questions.length ? _ref6 : null
    );
  };

  return GetStarted;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_6_unistore_preact__["connect"])('db')(GetStarted));

/***/ })

});


// WEBPACK FOOTER //
// route-get-started.chunk.98bb4.js